import { useGetAnalyticsFolderQuery } from '@/store/api';
/**
 * Platform-services hook for fetching the default analytics folder.
 *
 * @see src/store/api/cc/analyticsApi.ts
 */
export const useGetAnalyticsFolder = () => {
    const { data, isLoading, isFetching, isError, error, } = useGetAnalyticsFolderQuery();
    return {
        data,
        isLoading,
        isFetching,
        isError,
        error,
    };
};
